import React from "react";
import ContentLoader from "react-content-loader";

function ViewPageLoader(props) {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <ContentLoader
        speed={2}
        viewBox="0 0 1000 900"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        {...props}
      >
        <rect x="50" y="50" rx="1" ry="1" width="900" height="50" />
        <rect x="50" y="120" rx="1" ry="1" width="440" height="150" />
        <rect x="510" y="120" rx="1" ry="1" width="440" height="150" />
        <rect x="50" y="290" rx="1" ry="1" width="440" height="100" />
        <rect x="510" y="290" rx="1" ry="1" width="440" height="100" />

        <rect x="50" y="440" rx="1" ry="1" width="900" height="50" />
        <rect x="50" y="510" rx="1" ry="1" width="160" height="50" />
        <rect x="235" y="510" rx="1" ry="1" width="160" height="50" />
        <rect x="420" y="510" rx="1" ry="1" width="160" height="50" />
        <rect x="605" y="510" rx="1" ry="1" width="160" height="50" />
        <rect x="790" y="510" rx="1" ry="1" width="160" height="50" />

        <rect x="50" y="580" rx="1" ry="1" width="900" height="35" />
        <rect x="50" y="630" rx="1" ry="1" width="900" height="35" />
        <rect x="50" y="680" rx="1" ry="1" width="900" height="35" />
        <rect x="50" y="730" rx="1" ry="1" width="900" height="35" />
        <rect x="50" y="780" rx="1" ry="1" width="900" height="35" />
        <rect x="50" y="830" rx="1" ry="1" width="900" height="35" />
      </ContentLoader>
    </div>
  );
}

export default ViewPageLoader;
